// extracted by mini-css-extract-plugin
export default {"heru":"Heru_heru__sKUrt","content":"Heru_content__EDqBq","text":"Heru_text__w8JhM","imageCont":"Heru_imageCont__3Grl-","card_img":"Heru_card_img__gUAk6"};